import EmailFileAttachment from './Message/EmailFileAttachment';
import EmailDocumentAttachment from './Message/EmailDocumentAttachment';
import { Box } from '@mantine/core';

const Attachments = ({ eventId, attachments, documentBlueprints, deleteFileAttachment, deleteDocumentAttachment }) => {
  const fileAttachments = attachments || [];
  const blueprintAttachments = documentBlueprints || [];

  return (
    <Box
      sx={(theme) => ({
        alignItems: 'flex-start',
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing.xs,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
        '& > *': {
          flex: '0 1 auto',
          minWidth: 0,
          maxWidth: '100%',
        },
      })}
    >
      {fileAttachments.map((attachment, index) => (
        <EmailFileAttachment
          downloadable
          key={`file-${attachment.entityType}-${attachment.entityId}-${attachment.fileName}-${index}`}
          deleteAtIndex={deleteFileAttachment}
          index={index}
          attachment={attachment}
          eventId={eventId || undefined}
        />
      ))}
      {blueprintAttachments.map((attachment, index) => (
        <EmailDocumentAttachment
          key={`doc-${attachment.documentType}-${attachment.templateName || ''}-${index}`}
          deleteAtIndex={deleteDocumentAttachment}
          eventId={eventId || undefined}
          index={index}
          attachment={attachment}
        />
      ))}
    </Box>
  );
};

export default Attachments;
